module.exports = __webpack_public_path__ + "static/img/web_pg_2.77d29fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_pg_2.jpg
// module id = UR7F
// module chunks = 1